import * as BoxC from "./_ccbBoxC";
import * as SrlC from "./_ccbSrlC";
import * as GridC from "./_cccGridC";
import * as HtyC from "./_ccmHtyC";
import * as _cmFTH from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import { useCfmz } from "./_csMdlCfm";
import * as _cv_61___Ci from "./_cv_61___Ci";
import * as ht from './_ht';
import * as hf from './_hf';

import * as icvI10___Mz from './icvI10___Mz';
import * as icm from './icm';
import * as ihv from './ihv';

import * as e from './e.json';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  const _sCfmz = useCfmz();

  const _bfrUgd_61zAsync = async (_61z: ht.dz) => { // 休館日を外部連携

    const _gUserz = gs.useUserz();
    const _gStgz = gs.useStgz();

    const _i19rz = _gUserz.crt.i19rz;

    if (_i19rz.i19ra2410i == 1) { // 外部連携を行う場合

      /* !!!!!
    　単体部屋のみを対象に、単体部屋すべてをまとめて、施設全体の開始・終了時刻を連携
      !!!!! */

      const _i10rs = await icvI10___Mz.loadI10rLsAsync({
        _31r_fst: _gUserz.crt._31rz._fst,
      });

      const _roomIdz = icm.grtRoomIdz(_i10rs);

      await hf.ectSrlAsync(

        _61z._611s
        .map((_611z: ht.dz) => async () => { // 休館日各々について

          if (!_611z._key && _611z._dlt != 1) { // 新規登録の場合

            const _611a3100sj = {} as ht.dz;

            const _iptz = {
              login: _gStgz.crt.S91999112,
              password: _gStgz.crt.S91999122,
              date: _611z._icn,
              rsvid: 0, // 新規登録時は 0
              start: _gStgz.crt.S01999212,
              end: _gStgz.crt.S01999222,
              genFee: 0,
              yflg: '3',
              dname: '休館日',
              title: '休館日',
              ryokin: 0,
              feefree: '', // 料金手動入力
              rcvdate: _611z._icn,
              genmenflg: '',
              reason: '',
              bikou: '',
              yuusen: '',
              roomid: _roomIdz.prtRoomId,
              childRoomid: _roomIdz.cldRoomId,
              koukai: '',
              s0: 0, // 男性
              s1: 0, // 女性
              s2: 0, // 合計
              m1: 0, // 幼児
              m2: 0, // 小学生
              m3: 0, // 中学生
              m4: 0, // 高校生
              m5: 0, // 大学生
              m6: 0, // 一般男性
              f6: 0, // 一般女性
              m7: 0, // 65歳以上男性
              f7: 0, // 65歳以上女性
              mf: 0, // 合計
              kunai: 0, // 区内
              kugai: 0, // 区外
              shigai: 0, // 市内
              ssk: 0, // 合計
            };
            const _optz = await _cmFTH.ectAsync({
              tgt: 'ups2',
              dz: {
                ipt: encodeURIComponent(hf.s(_iptz)), // 外部連携時の文字化けを防ぐ
              }
            });
            if ( hf.chkType(hf.j(_optz.data), 'd') ) { // 更新に成功した場合
              const _rsvId = hf.j(_optz.data)?.rsvid;
              if ( _rsvId && _rsvId != 'NEW' ) {
                hf.udtDz(_611a3100sj, {
                  ... _roomIdz,
                  rsvId: _rsvId,
                });
              }
              else {
                const _tos = [] as ht.ls;
                const _gStgz = gs.useStgz();
                if ( hf.f(_gStgz.crt.S01050212) ) _tos.push(_gStgz.crt.S01050212);
                if ( hf.f(e.mailz.bcc) ) _tos.push(e.mailz.bcc);
                const _dz = ihv.mailz.lz.grtMailEtlErr2({
                  _31rz: _gUserz.crt._31rz,
                  i1zrz: {
                    _icn: '休館日',
                    i1zra1100s: '休館日',
                  },
                  iptz: _iptz,
                  optz: _optz,
                })
                const _mailz = {
                  ... _dz,
                  tos: _tos,
                };
                await _cmFTH.sendDrtMailAsync(_mailz);
              }
            }
            else {

              _sCfmz.show({
                pfx: `外部連携の際にエラーが発生しました。\n「${_optz.data}」`,
                ls: 
                [
                  { key: 1, pfx: 'はい' },
                ],
              });
              const _tos = [] as ht.ls;
              const _gStgz = gs.useStgz();
              if ( hf.f(_gStgz.crt.S01050212) ) _tos.push(_gStgz.crt.S01050212);
              if ( hf.f(e.mailz.bcc) ) _tos.push(e.mailz.bcc);
              const _dz = ihv.mailz.lz.grtMailEtlErr1({
                _31rz: _gUserz.crt._31rz,
                i1zrz: {
                  _icn: '休館日',
                  i1zra1100s: '休館日',
                },
                iptz: _iptz,
                optz: _optz,
              })
              const _mailz = {
                ... _dz,
                tos: _tos,
              };
              await _cmFTH.sendDrtMailAsync(_mailz);

            }

            hf.udtDz(_611z, {
              _611a3100s: hf.s(_611a3100sj),
            });

          }

          if (_611z._key > 0 && hf.f(_611z._611a3100s) && _611z._dlt == 1) { // 連携あり削除の場合

            const _611a3100sj = hf.j(_611z._611a3100s);

            const _iptz = {
              login: _gStgz.crt.S91999112,
              password: _gStgz.crt.S91999122,
              date: _611z._icn,
              rsvid: _611a3100sj.rsvId, // 新規登録時は 0
              start: _gStgz.crt.S01999212,
              end: _gStgz.crt.S01999222,
              genFee: 0,
              yflg: '-2',
              dname: '休館日',
              title: '休館日',
              ryokin: 0,
              feefree: '', // 料金手動入力
              rcvdate: _611z._icn,
              genmenflg: '',
              reason: '',
              bikou: '',
              yuusen: '',
              roomid: _611a3100sj.prtRoomId,
              child: _611a3100sj.cldRoomId,
              koukai: '',
              s0: 0, // 男性
              s1: 0, // 女性
              s2: 0, // 合計
              m1: 0, // 幼児
              m2: 0, // 小学生
              m3: 0, // 中学生
              m4: 0, // 高校生
              m5: 0, // 大学生
              m6: 0, // 一般男性
              f6: 0, // 一般女性
              m7: 0, // 65歳以上男性
              f7: 0, // 65歳以上女性
              mf: 0, // 合計
              kunai: 0, // 区内
              kugai: 0, // 区外
              shigai: 0, // 市内
              ssk: 0, // 合計
            };
            const _optz = await _cmFTH.ectAsync({
              tgt: 'ups2',
              dz: _iptz
            });

            if ( hf.chkType(hf.j(_optz.data), 'd') ) { // 更新に成功した場合

              const _rsvId = hf.j(_optz.data)?.rsvid;
              if ( _rsvId && _rsvId != 'NEW' ) {

                // 対応事項なし

              }
              else {
                const _tos = [] as ht.ls;
                const _gStgz = gs.useStgz();
                if ( hf.f(_gStgz.crt.S01050212) ) _tos.push(_gStgz.crt.S01050212);
                if ( hf.f(e.mailz.bcc) ) _tos.push(e.mailz.bcc);
                const _dz = ihv.mailz.lz.grtMailEtlErr2({
                  _31rz: _gUserz.crt._31rz,
                  i1zrz: {
                    _icn: '休館日',
                    i1zra1100s: '休館日',
                  },
                  iptz: _iptz,
                  optz: _optz,
                })
                const _mailz = {
                  ... _dz,
                  tos: _tos,
                };

                await _cmFTH.sendDrtMailAsync(_mailz);
              }

            }
            else {

              _sCfmz.show({
                pfx: `外部連携の際にエラーが発生しました。\n「${_optz.data}」`,
                ls: 
                [
                  { key: 1, pfx: 'はい' },
                ],
              });
              const _tos = [] as ht.ls;
              const _gStgz = gs.useStgz();
              if ( hf.f(_gStgz.crt.S01050212) ) _tos.push(_gStgz.crt.S01050212);
              if ( hf.f(e.mailz.bcc) ) _tos.push(e.mailz.bcc);
              const _dz = ihv.mailz.lz.grtMailEtlErr1({
                _31rz: _gUserz.crt._31rz,
                i1zrz: {
                  _icn: '休館日',
                  i1zra1100s: '休館日',
                },
                iptz: _iptz,
                optz: _optz,
              })
              const _mailz = {
                ... _dz,
                tos: _tos,
              };

              await _cmFTH.sendDrtMailAsync(_mailz);

            }
          }

        })

      )

    }

  }

  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnStfz',
          boxStlz: a(`mb/2`),
          lineCs: [{
            cellCs: [
              {
                oClds: [
                ]
              },
              {
                oClds: [
                ]
              },
              {
                oClds: [
                  cr.c(HtyC.N, {
                    key: -10,
                    sPz: pz.sPz,
                    cz: {
                      elm: '_61r',
                    }
                  })

                ]
              }
            ]
          }]
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [

            cr.c(SrlC.V, {
              key: -20,
              abtType: 'cttCmnz',
              oClds: [
                cr.c(_cv_61___Ci.D, {
                  key: -20,
                  sPz: pz.sPz,
                }),
              ],
            }),

            cr.c(_cv_61___Ci.B, {
              key: -30,
              sPz: pz.sPz,
              cz: {
                lblz: pz.sPz.crt.lblz,
                sc: 'gn7',
                bfrUgdAsync: _bfrUgd_61zAsync,
              },
            }),

          ]
        })

      ]
    })
  );
};

